import ToolLandingTemplate from '../../components/landing/ToolLandingTemplate';
import { LIVE_TOOLS } from '../../data/tools';
import { sizeConverterLanding } from '../../content/sizeConverterContent';

const tool = LIVE_TOOLS.find((t) => t.id === 'clothing-shoe-size-converter');

export default function SizeConverterLanding() {
  return <ToolLandingTemplate tool={tool} {...sizeConverterLanding} />;
}
